/**
 * Brand theming for every Clerk surface, lifted verbatim out of the Next root
 * layout during the SPA conversion. Consumed by `RootLayout`.
 */
// Brand theming for every Clerk surface: sign-in, sign-up, user button menu,
// account portal, etc. Variables pull from the brand tokens in globals.css —
// coral primary, ink text, ivory app background.
export const clerkAppearance = {
  variables: {
    colorPrimary: 'hsl(4 94% 64%)', // --coral
    colorBackground: '#ffffff',
    colorText: 'hsl(0 5% 12%)', // --black / ink
    colorTextSecondary: 'hsl(0 5% 12% / 0.6)',
    colorInputBackground: '#ffffff',
    colorInputText: 'hsl(0 5% 12%)',
    colorDanger: '#dc2626',
    colorSuccess: '#16a34a',
    borderRadius: '0.75rem',
    fontFamily: 'inherit',
    fontFamilyButtons: 'inherit',
    fontSize: '0.875rem',
  },
  elements: {
    modalContent: 'w-full overflow-hidden rounded-2xl bg-white',
    // NOTE: `rootBox` is intentionally NOT styled here. It is the outermost
    // wrapper shared by every Clerk component (SignIn, SignUp, UserButton,
    // …), so full-width white-card styling on it bleeds into the sidebar
    // avatar. The auth widgets opt into a full-width rootBox themselves via
    // `authWidgetAppearance`; card-specific slots below are safe globally.
    cardBox: 'w-full overflow-hidden rounded-2xl bg-white',
    card: 'w-full rounded-2xl border-0 bg-white shadow-2xl',
    // Hide Clerk's built-in title/subtitle. The combined /login page renders
    // its own heading and copy above the widget
    // — the duplicate inside the card felt redundant. We only hide the
    // text elements (NOT the parent `header` slot) to avoid Clerk
    // bundling the form body inside the header wrapper in some versions.
    headerTitle: 'hidden',
    headerSubtitle: 'hidden',
    formButtonPrimary:
      'rounded-full bg-coral hover:bg-coral/90 active:bg-coral text-white font-bold text-sm normal-case shadow-sm transition',
    formFieldInput:
      'rounded-lg border-black/15 focus:border-coral focus:ring-2 focus:ring-coral/15 text-ink',
    formFieldLabel: 'text-ink font-bold text-sm',
    socialButtonsBlockButton:
      'rounded-full border border-black/15 hover:bg-black/[0.03] text-ink font-bold normal-case',
    socialButtonsBlockButtonText: 'font-bold text-ink',
    dividerLine: 'bg-black/10',
    dividerText: 'text-ink/55 text-xs uppercase tracking-wide font-bold',
    // Clerk's full footer (cross-link card + secured-by + terms) is
    // hidden because the combined /login page renders its own legal notice below the widget.
    footer: 'hidden',
    footerAction: 'hidden',
    footerActionText: 'hidden',
    footerActionLink: 'hidden',
    formFieldInputShowPasswordButton: 'text-ink/45 hover:text-ink',
    identityPreviewText: 'text-ink',
    identityPreviewEditButton: 'text-coral',
    userButtonPopoverCard: 'rounded-2xl border border-black/10 shadow-2xl',
    userButtonPopoverActionButton: 'text-ink hover:bg-black/[0.04]',
    userButtonPopoverActionButtonText: 'font-bold',
    userPreviewMainIdentifier: 'text-ink font-bold',
    userPreviewSecondaryIdentifier: 'text-ink/55',
  },
  options: {
    termsPageUrl: '/terms',
    privacyPageUrl: '/privacy',
  },
} as const;

export const clerkLocalization = {
  footerPageLink__privacy: 'Privacy',
  footerPageLink__terms: 'Terms',
} as const;
